<template>
	<div v-if="list.length > 0" class="previous-next">
		<span :class="['previous', { disabled: currentIndex == 0 }]" @click="getPreviousItem()">&lang; Prev</span>
		<span :class="['next', { disabled: currentIndex == list.length - 1 }]" @click="getNextItem()">Next &rang;</span>
	</div>
</template>

<script>
export default {
	name: 'pagination-detail',
	props: ['list', 'index'],
    data () {
        return {
	        currentIndex: 1
	    }
    },
    created() {
		this.currentIndex = this.index || 1
	},
	watch: {
		list: function(newSet,oldSet) {
			this.currentIndex = this.index || 1
		}
	},
	methods: {
		getPreviousItem() {
			if (this.currentIndex == 0) { return }
			this.currentIndex--
			this.$emit('updatePage', this.list[this.currentIndex])
		},
		getNextItem() {
			if (this.currentIndex == this.list.length - 1) { return }
			this.currentIndex++
			this.$emit('updatePage', this.list[this.currentIndex])
		}
	}
}
</script>
